import { Navbar } from "../Navbar/Navbar";
import "./ProjectsHeader.css";

const ProjectsHeader = () => {
    return (
        <section className="projects-hero">
            <div className="projects-hero-content">
                <Navbar />
                {/* <span className="projects-tag">Our Portfolio</span> */}

                <h1>Explore Our Design Journey</h1>

                <p>
                    Discover the homes we’ve transformed — from modular kitchens
                    to complete end-to-end interior projects crafted with precision.
                </p>

                <a href="#projects" className="projects-btn">
                    View Projects
                </a>

            </div>
        </section>
    );
}


export { ProjectsHeader };